import {
    CostCenter,
    CostCenter2,
    DocumentTypeEnum,
    Employee,
    ExpenseRequestTypeEnum,
    ExpenseStatusEnum,
    ExportFormatEnum,
    Vendor,
    Expense,
    CreditorInterface,
} from "@finway-group/shared/lib/models"
import { ExpensePaymentOptionEnum } from "@finway-group/shared/lib/models/expense/expensePaymentOption.enum"
import { Button, Card } from "antd"
import RejectModal from "Components/modals/rejectModal"
import React, { useState } from "react"
import { Bell as BellIcon, X as CancelIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { ReadOnlyContext } from "Shared/context/readOnly.context"
import { useAreCardsActivated } from "Shared/hooks/corporate.hooks"
import ExpenseActionButtonView from "./expenseActionButtonView"
import ExpenseCreditCardSection from "./expenseCreditCardSection"
import ExpenseSourceSection from "./expenseSourceSection"
interface ExpenseRightSectionInterface {
    expense: Expense
    loggedInUser: Employee
    vendor: CreditorInterface
    approver: Employee
    requestedBy: Employee
    costCenter: CostCenter
    costCenter2?: CostCenter2
    requestType: ExpenseRequestTypeEnum | undefined
    isInvoiceUploading: boolean
    isDeliveryNoteUploading: boolean
    isLoading: boolean
    nextExpense: string
    cancelRequest: () => void
    sendEmailReminder: () => void
    markRequestAsApproved: (expense: Expense, userId: string) => void
    markRequestAsReviewed: () => void
    markRequestAsPaid: () => void
    payExpense: (isScheduledPayment: boolean) => void
    doFileUpload: (file: any, kind: DocumentTypeEnum) => void
    onInboxSelected: (event: any) => void
    isOcrUploading: boolean
    isExpenseUpdating: boolean
    setIsExpenseUpdating: React.Dispatch<React.SetStateAction<boolean>>
}
const ExpenseRightSection: React.FC<ExpenseRightSectionInterface> = ({
    expense,
    loggedInUser,
    vendor,
    requestedBy,
    approver,
    costCenter,
    costCenter2,
    requestType,
    isInvoiceUploading,
    isDeliveryNoteUploading,
    isLoading,
    nextExpense,
    cancelRequest,
    sendEmailReminder,
    markRequestAsApproved,
    markRequestAsReviewed,
    markRequestAsPaid,
    payExpense,
    doFileUpload,
    onInboxSelected,
    isOcrUploading,
    isExpenseUpdating,
    setIsExpenseUpdating,
}) => {
    const { t } = useTranslation()
    const isReadOnly = React.useContext(ReadOnlyContext).isReadOnly
    const [isRejectModalVisible, setIsRejectModalVisible] = useState<boolean>(false)
    const isSubscription = expense.isSubscription()
    const isMyExpense = expense.isCurrentUserExpense(loggedInUser.id)
    const cardsActive = useAreCardsActivated()
    const showCard = !isReadOnly && cardsActive && expense.paymentOption === ExpensePaymentOptionEnum.SMART_CARD && (expense.status !== ExpenseStatusEnum.DECLINED || expense.card)

    return (
        <>
            <RejectModal
                isVisible={isRejectModalVisible}
                title={t("notification:rejection_note.title")}
                message={t("notification:rejection_note.message")}
                cancelText={t("notification:rejection_note.cancel")}
                okText={t("notification:rejection_note.confirm")}
                request={expense}
                nextExpense={nextExpense}
                onCancel={() => setIsRejectModalVisible(false)}
            />

            <Card className="border-b-0" id="expense-action-section" style={{ zIndex: 1 }}>
                <div>
                    {isMyExpense ? (
                        <>
                            <h2 className="mb-0 pl-0 -mt-3">{t("label:approval_pending")}</h2>
                            <p className="mb-5">{t("label:approval_pending_desc")}</p>
                            <div className="btn-wrapper sm:flex-col lg:flex-row flex-wrap-reverse fixed left-0 right-0 bottom-0 py-16 px-10 bg-white shadow sm:relative sm:left-auto sm:right-auto sm:bottom-auto sm:p-0 sm:pt-12 sm:pb-2 sm:bg-transparent sm:shadow-none z-20 sm:z-0">
                                <Button className="flex-1 btn-default m-2 p-5" onClick={cancelRequest}>
                                    <CancelIcon />
                                    <span>{t("action:cancel_request")}</span>
                                </Button>
                                {/* DO not remove  md:mt-10 lg:mt-0 md:ml-0 lg:ml-10 */}
                                <Button className="flex-1 btn-highlight-blue m-2 p-5" onClick={sendEmailReminder}>
                                    <BellIcon />
                                    <span className="m-0">{t("action:send_reminder")}</span>
                                </Button>
                            </div>
                        </>
                    ) : (
                        <ExpenseActionButtonView
                            expense={expense}
                            loggedInUser={loggedInUser}
                            isSubscription={isSubscription}
                            isLoading={isLoading}
                            isInvoiceUploading={isInvoiceUploading}
                            markRequestAsApproved={markRequestAsApproved}
                            rejectRequest={() => setIsRejectModalVisible(true)}
                            markRequestAsReviewed={markRequestAsReviewed}
                            markRequestAsPaid={markRequestAsPaid}
                            doFileUpload={doFileUpload}
                            payExpense={payExpense}
                            onInboxSelected={onInboxSelected}
                            isOcrUploading={isOcrUploading}
                            sendEmailReminder={sendEmailReminder}
                            isExpenseUpdating={isExpenseUpdating}
                        />
                    )}
                </div>
            </Card>

            {showCard && <ExpenseCreditCardSection expense={expense} />}

            <ExpenseSourceSection
                expense={expense}
                loggedInUser={loggedInUser}
                vendor={vendor}
                approver={approver}
                requestedBy={requestedBy}
                costCenter={costCenter}
                costCenter2={costCenter2!}
                requestType={requestType}
                isDeliveryNoteUploading={isDeliveryNoteUploading}
                doFileUpload={doFileUpload}
                setIsExpenseUpdating={setIsExpenseUpdating}
            />
        </>
    )
}

export default ExpenseRightSection
